import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import tabsResources from './tabsResources';
import cartResources from './cartResources';
import cardsResources from './cardsResources';
import headerResources from './headerResources';
import stocksResources from './stocksResources';
import faqResources from './faqResources';
import contactsResources from './contactsResources';
import footerResources from './footerResources';
import autoInsuranceResources from './autoInsuranceResources';
import cityListResources from './cityListResources';
import cascoResources from './cascoPageResources';
import cascoClientResources from './cascoClientPageResources';
import cascoPartnerResources from './cascoPartnerPageResources';
import ogpovtsResources from './ogpovtsPageResources';
import carrierLiabilityResources from './carrierLiabilityPageResources';
import dsgpoResources from './dsgpoPageResources';
import abroadResources from './abroadPageResources';
import neighborhoodResources from './neighborhoodPageResources';
import propertyResources from './propertyPageResources';
import sportResources from './sportPageResources';
import nonResidentResources from './nonResidentPageResources';
import childrenResources from './childrenPageResources';
import accidentResources from './accidentPageResources';
import licensesResources from './companyPages/licensesResources';
import insuranceRulesResources from './companyPages/insuranceRulesResources';
import tariffsResources from './tariffsPageResources';
import contactsCompanyResources from './companyPages/contactsCompanyResources';
import docsResources from './companyPages/docsResources';
import privacyResources from './companyPages/privacyResources';
import comissionsResources from './companyPages/commissionsResources';
import groupResources from './companyPages/groupResources';
import careerResources from './companyPages/careerResources';
import pageListResources from './companyPages/pageListResources';
import flutterProducts from './flutterPages/flutterProductsRes';
import flutterAuto from './flutterPages/flutterAutoRes';
import flutterHealth from './flutterPages/flutterHealthRes';
import flutterProperty from './flutterPages/flutterPropertyRes';
import flutterTravel from './flutterPages/flutterTravelRes';
import flutterPassengers from './flutterPages/flutterPassengers';
import flutterBuy from './flutterPages/flutterBuyRes';
import flutterCabinet from './flutterPages/flutterCabinetRes';
import financeResources from './companyPages/financeResources';
import assetsResources from './assetsResources';
import carouselResources from './carouselResources';
import insuranceResources from './insuranceResources';
import checkPolicyResources from './checkPolicyResources';
import insuranceCasePageResources from './insuranceCasePageResources';
import agentsPageResources from './agentsPageResources';
import mycarResources from '../features/mycar/locale/translations';
import translationsPrivacyRadio from '../components/PrivacyRadio/translations-privacy-radio';
import cascoMyCarCreditResources from './cascoMyCarCreditResources';
import voluntaryContractResources from '../pages/web_version/products/business_insurance/voluntary-contractual/voluntaryContractResources';
import businessInsuranceResource from './businessInsuranceResources';
import voluntaryCargoResources from '../pages/web_version/products/business_insurance/voluntary-cargo/voluntaryCargoResources';
import voluntaryPropertyResources from '../pages/web_version/products/business_insurance/voluntary-property/voluntaryPropertyResources';
import voluntaryTransportResources from '../pages/web_version/products/business_insurance/voluntary-transport/voluntaryTransportResources';
import voluntaryHealthResources from '../pages/web_version/products/business_insurance/voluntary-health/voluntaryHealthResources';
import ogpoResources from '../pages/web_version/products/business_insurance/ogpo/ogpoResources';
import ecologyResources from '../pages/web_version/products/business_insurance/ecology/ecologyResources';
import otherResources from './otherResources';
import carCalcResources from './carCalcResources';
import casco4resources from '../features/casco-4/translations';
import docVerifyResources from '../features/check-doc-qr/locale/doc-verify.translations';
import jobLossTranslations from '../features/job-loss/locale/job-loss-translations';

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
  en: {
    translation: {
      ok: 'OK',
      cancel: 'Cancel',
      ...headerResources.en.translation,
      ...tabsResources.en.translation,
      ...cartResources.en.translation,
      ...stocksResources.en.translation,
      ...cardsResources.en.translation,
      ...faqResources.en.translation,
      ...contactsResources.en.translation,
      ...footerResources.en.translation,
      ...autoInsuranceResources.en.translation,
      ...cityListResources.en.translation,
      ...businessInsuranceResource.en.translation,
    },
    ...cascoResources.en,
    ...cascoMyCarCreditResources.en,
    ...cascoClientResources.en,
    ...cascoPartnerResources.en,
    ...ogpovtsResources.en,
    ...translationsPrivacyRadio.en,
    ...carrierLiabilityResources.en,
    ...dsgpoResources.en,
    ...abroadResources.en,
    ...neighborhoodResources.en,
    ...propertyResources.en,
    ...sportResources.en,
    ...nonResidentResources.en,
    ...childrenResources.en,
    ...accidentResources.en,
    ...assetsResources.en,
    ...carouselResources.en,
    ...insuranceResources.en,
    ...checkPolicyResources.en,
    ...insuranceCasePageResources.en,
    ...agentsPageResources.en,

    ...licensesResources.en,
    ...insuranceRulesResources.en,
    ...tariffsResources.en,
    ...contactsCompanyResources.en,
    ...docsResources.en,
    ...privacyResources.en,
    ...comissionsResources.en,
    ...groupResources.en,
    ...careerResources.en,
    ...pageListResources.en,
    ...financeResources.en,

    ...flutterProducts.en,
    ...flutterAuto.en,
    ...flutterHealth.en,
    ...flutterProperty.en,
    ...flutterTravel.en,
    ...flutterPassengers.en,
    ...flutterBuy.en,
    ...flutterCabinet.en,

    ...mycarResources.en,
    ...docVerifyResources.en,
    ...casco4resources.en,

    ...voluntaryContractResources.en,
    ...voluntaryCargoResources.en,
    ...voluntaryPropertyResources.en,
    ...voluntaryTransportResources.en,
    ...voluntaryHealthResources.en,
    ...ogpoResources.en,
    ...ecologyResources.en,
    ...otherResources.en,
    ...carCalcResources.en,
    ...jobLossTranslations.en,
  },
  kz: {
    translation: {
      ok: 'OK',
      cancel: 'Бас тарту',
      ...headerResources.kz.translation,
      ...tabsResources.kz.translation,
      ...cartResources.kz.translation,
      ...stocksResources.kz.translation,
      ...cardsResources.kz.translation,
      ...faqResources.kz.translation,
      ...contactsResources.kz.translation,
      ...footerResources.kz.translation,
      ...autoInsuranceResources.kz.translation,
      ...cityListResources.kz.translation,
      ...businessInsuranceResource.kz.translation,
    },
    ...cascoResources.kz,
    ...cascoMyCarCreditResources.kz,
    ...cascoClientResources.kz,
    ...cascoPartnerResources.kz,
    ...ogpovtsResources.kz,
    ...translationsPrivacyRadio.kz,

    ...carrierLiabilityResources.kz,
    ...dsgpoResources.kz,
    ...abroadResources.kz,
    ...neighborhoodResources.kz,
    ...propertyResources.kz,
    ...sportResources.kz,
    ...nonResidentResources.kz,
    ...childrenResources.kz,
    ...accidentResources.kz,
    ...assetsResources.kz,
    ...carouselResources.kz,
    ...insuranceResources.kz,
    ...checkPolicyResources.kz,
    ...insuranceCasePageResources.kz,
    ...agentsPageResources.kz,

    ...licensesResources.kz,
    ...insuranceRulesResources.kz,
    ...tariffsResources.kz,
    ...contactsCompanyResources.kz,
    ...docsResources.kz,
    ...privacyResources.kz,
    ...comissionsResources.kz,
    ...groupResources.kz,
    ...careerResources.kz,
    ...pageListResources.kz,
    ...financeResources.kz,

    ...flutterProducts.kz,
    ...flutterAuto.kz,
    ...flutterHealth.kz,
    ...flutterProperty.kz,
    ...flutterTravel.kz,
    ...flutterPassengers.kz,
    ...flutterBuy.kz,
    ...flutterCabinet.kz,
    ...mycarResources.kz,
    ...docVerifyResources.kz,
    ...casco4resources.kz,

    ...voluntaryContractResources.kz,
    ...voluntaryCargoResources.kz,
    ...voluntaryPropertyResources.kz,
    ...voluntaryTransportResources.kz,
    ...voluntaryHealthResources.kz,
    ...ogpoResources.kz,
    ...ecologyResources.kz,
    ...otherResources.kz,
    ...carCalcResources.kz,
    ...jobLossTranslations.kz,
  },
  ru: {
    translation: {
      ok: 'OK',
      cancel: 'Отмена',
      ...headerResources.ru.translation,
      ...tabsResources.ru.translation,
      ...cartResources.ru.translation,
      ...stocksResources.ru.translation,
      ...cardsResources.ru.translation,
      ...faqResources.ru.translation,
      ...contactsResources.ru.translation,
      ...footerResources.ru.translation,
      ...autoInsuranceResources.ru.translation,
      ...cityListResources.ru.translation,
      ...businessInsuranceResource.ru.translation,
    },
    ...cascoResources.ru,
    ...cascoMyCarCreditResources.ru,
    ...cascoClientResources.ru,
    ...cascoPartnerResources.ru,
    ...ogpovtsResources.ru,
    ...translationsPrivacyRadio.ru,
    ...carrierLiabilityResources.ru,
    ...dsgpoResources.ru,
    ...abroadResources.ru,
    ...neighborhoodResources.ru,
    ...propertyResources.ru,
    ...sportResources.ru,
    ...nonResidentResources.ru,
    ...childrenResources.ru,
    ...accidentResources.ru,
    ...assetsResources.ru,
    ...carouselResources.ru,
    ...insuranceResources.ru,
    ...checkPolicyResources.ru,
    ...insuranceCasePageResources.ru,
    ...agentsPageResources.ru,

    ...licensesResources.ru,
    ...insuranceRulesResources.ru,
    ...tariffsResources.ru,
    ...contactsCompanyResources.ru,
    ...docsResources.ru,
    ...privacyResources.ru,
    ...comissionsResources.ru,
    ...groupResources.ru,
    ...careerResources.ru,
    ...pageListResources.ru,
    ...financeResources.ru,

    ...flutterProducts.ru,
    ...flutterAuto.ru,
    ...flutterHealth.ru,
    ...flutterProperty.ru,
    ...flutterTravel.ru,
    ...flutterPassengers.ru,
    ...flutterBuy.ru,
    ...flutterCabinet.ru,
    ...mycarResources.ru,
    ...docVerifyResources.ru,
    ...casco4resources.ru,

    ...voluntaryContractResources.ru,
    ...voluntaryCargoResources.ru,
    ...voluntaryPropertyResources.ru,
    ...voluntaryTransportResources.ru,
    ...voluntaryHealthResources.ru,
    ...ogpoResources.ru,
    ...ecologyResources.ru,
    ...otherResources.ru,
    ...carCalcResources.ru,
    ...jobLossTranslations.ru,
  },
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: 'kz', // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
